import { create } from 'zustand';

export const AUTO_CLOSE_MS = 5000;

export const useResultStore = create((set, get) => ({
	isOpen: false,
	type: '',
	text: '',
	// Errors stay until dismissed so there is time to read the server's reason (see ResultAlert for page changes).
	timeout: AUTO_CLOSE_MS,
	// Bumped on every open so a new message restarts the auto-close timer.
	messageId: 0,
	closeSubScriber: null,
	failList: [],
	open: ({ type, text }) => {
		set((state) => ({
			...state,
			isOpen: true,
			type,
			text,
			timeout: type === 'error' ? null : AUTO_CLOSE_MS,
			messageId: state.messageId + 1,
		}));
	},
	clear: () => {
		set((state) => ({ ...state, isOpen: false, type: '', text: '' }));
		get().closeSubScriber && get().closeSubScriber();
	},
	clearFailList: () => {
		set((state) => ({ ...state, failList: [] }));
	},
	setFailList: (failList) => {
		set((state) => ({ ...state, failList }));
	},
}));
